<template lang="pug" src="./adminAds.pug"></template>

<script>
import { isFuture } from 'date-fns'
import { mapActions } from 'vuex'
import { localize } from 'vee-validate'

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

  export default {
    data: function() {
          return {
       isReading: true,
       isEmpty: false,
       show: true,
       loadingCard:[],
       ativo: [],
       filter: '',
       filter_items: [
          { text: `${this.$t('adminAds.ACTIVES')}`, value: '0'},
          { text: `${this.$t('adminAds.INACTIVE')}`, value: '1'},
          { text: `${this.$t('adminAds.SCHEDULED')}`, value: '2'}
       ],
       filtered: [],
       bucketHs: ''
     }
   },

     methods: {
       ...mapActions(['getAds', 'disableAds']),

       filterArray(filtros){

         var newArray = []

         if (Object.values(filtros).includes('0')) {
           var ativos = this.ads.filter(function(value){ return value.ativo == true })
           newArray.push.apply(newArray, ativos)
         }

         if (Object.values(filtros).includes('1')) {
           var inativos = this.ads.filter(function(value){ return value.ativo == false })
           newArray.push.apply(newArray, inativos)
         }

         if (Object.values(filtros).includes('2')) {
           var agendados = this.ads.filter(function(value){
             return isFuture(new Date(value.intervalo.inicio))
           })
           newArray.push.apply(newArray, agendados)
         }

        if(filtros.length == 0){
            newArray = this.ads
        }

        newArray = [...new Set(newArray)]

        newArray.sort(function(a, b) { // ordenar por data de inicio
          var keyA = new Date(a.intervalo.inicio),
            keyB = new Date(b.intervalo.inicio)
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        })

        this.filtered = newArray

       },

       async getAdsFromHs(){

         this.bucketHs = 'c_'+window.localStorage.getItem('selectedHotspot').split('"').join('').substr(0, window.localStorage.getItem('selectedHotspot').split('"').join('').indexOf('_'))

         this.isReading = true
         this.isEmpty = false

         await this.getAds({
           identity: window.localStorage.getItem('selectedHotspot').split('"').join('')
         })

         this.isReading = false

         if(this.ads.length == 0){ this.isEmpty = true }

         this.ads.forEach((item) => {
           this.loadingCard.push({key:item._id, value:false})
           if(item.ativo){
             this.ativo.push(item._id)
           }
         })

         this.ads.sort(function(a, b) { // ordenar por data de inicio
           var keyA = new Date(a.intervalo.inicio),
             keyB = new Date(b.intervalo.inicio)
           if (keyA < keyB) return -1;
           if (keyA > keyB) return 1;
           return 0;
         })

         this.filtered = this.ads
        },

        async disable(id){
          this.loadingCard[id] = true
          const selectedCampain = this.ads.filter(x => x._id === id)

          await this.disableAds({
              _id: id,
              campanha: selectedCampain[0].campanha,
              urlDestino: selectedCampain[0].urlDestino,
              urlApp: selectedCampain[0].urlApp,
              diasSemana: selectedCampain[0].diasSemana,
              intervalo: selectedCampain[0].intervalo,
              horas: selectedCampain[0].horas,
              identity: selectedCampain[0].identity,
              nomeArquivo: selectedCampain[0].nomeArquivo,
              ativo: !selectedCampain[0].ativo
          })

          selectedCampain[0].ativo = !selectedCampain[0].ativo
          this.loadingCard[id] = false
        }

     },

     computed: {

         selectedHs () {
           return this.$store.state.adminHotspots.selectedHotspot
         },

         ads(){
           return this.$store.state.adminAds.ads
         }

     },

    created () {
      this.getAdsFromHs()
    },

    watch: {
      //selectedHs (newselectedHs, oldselectedHs) {
      selectedHs () {
        this.getAdsFromHs()
      },

      lang (newLang) { // se trocou a linguagem, revalida o form
        const lg = { en: en, pt: pt_BR, es: es };
        localize(`${newLang}`, lg[newLang]);

        this.$refs.form.validate();
      }
   }
 }
</script>
<style>
  .disabledAds{
    filter: grayscale(90%)
  }
  .rounded-card{
    overflow: hidden;
  }
  .v-card__text, .v-card__title {
    word-break: normal; /* maybe !important  */
  }
</style>
